import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactToPrint from "react-to-print";
import "./bilty.css";
const Printbilty = ({ details, handleClose2, changeCss }) => {
  console.log("details: ", details);
  const [isJadu, setIsJadu] = useState(false);
  const profileDetails = useSelector((state) => state.dataReducer.profile);
  console.log(
    "profileDetails: ",
    profileDetails?.pro?.name ?? "No name available"
  );
  const navigate = useNavigate();
  let componentRef = useRef();
  useEffect(() => {
    if (typeof changeCss === "boolean") {
      setIsJadu(changeCss);
    }
  }, [changeCss]);
  const goBack = () => {
    // document.getElementById("biltyform").classList.toggle("c-form");
    // document.getElementById("printing").classList.toggle("jadu");
    // document.getElementById("bilty-template").classList.toggle("jadu");
    console.log("hello");
    navigate("/dashbaord/chalan/chalans");
  };
  return (
    <>
      <div
        className={`print-container ${isJadu ? "" : "jadu"}`}
        id="bilty-template"
      >
        {/* <div> */}
        <div
          id="printing"
          className="printing"
          ref={(el) => (componentRef = el)}
        >
          <table className="Maintable">
            <tr
              className="one1"
              id="print"
              style={{ backgroundColor: "#d8d8d8" }}
            >
              <td colSpan="7">
                <span className="CompanyName">
                  {profileDetails && profileDetails.pro
                    ? profileDetails.pro["name"]
                    : "---"}
                </span>
              </td>
            </tr>

            <tr className="twoo">
              <td colSpan="5" rowSpan={2} style={{ width: "50%" }}>
                <p>
                  {profileDetails && profileDetails.pro
                    ? profileDetails.pro["address"]
                    : "---"}
                </p>
              </td>

              <td colSpan="2">
                <p>Consignment Note</p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}></td>
            </tr>

            <tr className="twoo1">
              <td rowSpan="2" colSpan={2}></td>
              <td colSpan={3}>
                <p>
                  <b>
                    Mob No :-
                    {profileDetails?.pro
                      ? profileDetails.pro.phone_no ?? "---"
                      : "---"}
                    {/* {profileDetails &&
                  profileDetails.pro &&
                  profileDetails.pro.length > 0
                  ? profileDetails.pro[0]["address"]
                  : "---"} */}
                  </b>
                </p>
              </td>

              <td rowSpan="2" colSpan="2">
                <b>
                  <h2>{details?.challan_number}</h2>
                </b>
              </td>
            </tr>
            <tr className="twoo2">
              <td colSpan={3}>
                <p>
                  <b>GST No</b> :-{" "}
                  {profileDetails?.pro && profileDetails.pro.gst_no
                    ? profileDetails.pro.gst_no
                    : "---"}{" "}
                </p>
                <p>
                  <b> PAN No</b> :-{" "}
                  {/* {profileDetails?.pro[0]?.pan_card ?? "---"} */}
                  {profileDetails?.pro && profileDetails.pro.pan_card
                    ? profileDetails.pro.pan_card
                    : "---"}
                </p>
              </td>
            </tr>

            <tr className="section_break">
              <td colSpan={7} style={{ backgroundColor: "#f2f2f2" }}></td>
            </tr>
            <tr className="Invoice_section">
              <td>
                <b>Invoice No.</b>
              </td>
              <td colSpan={2}>{details.invoice_no}</td>
              <td colSpan={2}>
                <b>
                  <b>Invoice Date</b>
                </b>
              </td>
              <td colSpan={2}>{details.invoice_date}</td>
            </tr>

            <tr className="section_break">
              <td colSpan={7} style={{ backgroundColor: "#f2f2f2" }}></td>
            </tr>

            <tr className="three">
              <td colSpan={2}>
                <b>Date: </b>
              </td>
              <td>{new Date().toLocaleDateString("en-GB")}</td>

              <td>
                <b>Consignor</b>
              </td>
              <td></td>
              <td colSpan={2} style={{ textAlign: "center" }}>
                <b>
                  <u>NOTICE:</u>
                </b>
              </td>
              {/* <td>From :{details.from}</td>
                  <td>To :</td>
                  <td>Truck Number :</td>  */}
            </tr>
            <tr>
              <td colSpan={2}>
                <b>From:</b>
              </td>
              <td>{details.from}</td>
              <td>
                <b>Consignee</b>
              </td>
              <td></td>
              <td rowSpan="3" colSpan={2}>
                <p className="Noticedetails">
                  The consignment covered by this set of special lorry receipt
                  from shall be stored at the destination under the control of
                  the transport operator & shall be delivered to or order of the
                  consignee bank whose name is mentioned in the lorry receipt it
                  will under no circumstances be delivered to any one without
                  the written authority from the consignee bank or its order
                  endorsed on consignee copy or on separate letter of Authority.
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <b>To :</b>
              </td>
              <td>{details.to}</td>
              <td rowSpan="2">
                <b>Transport</b>
              </td>
              <td rowSpan="2" style={{ textAlign: "center" }}>
                <h2> √ </h2>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <b>Truck No. :</b>
              </td>
              <td>{details.truck_no}</td>
            </tr>

            <tr className="section_break">
              <td colSpan={7} style={{ backgroundColor: "#f2f2f2" }}></td>
            </tr>

            <tr className="four">
              <td>
                <b>Consignor :</b>
              </td>
              <td colSpan={2}>{details.consignor}</td>
              <td colSpan={2}>
                <b>Consignee :</b>
              </td>
              <td colSpan={2}>{details.consignee}</td>
            </tr>
            <tr>
              <td>
                <b>Address : </b>
              </td>
              <td colSpan={2}>{details.consignor_address}</td>
              <td colSpan={2}>
                <b>Address :</b>
              </td>
              <td colSpan={2}>
                {details.consignee_address1} {details.consignee_address2}
              </td>
            </tr>
            <tr>
              <td>
                <b>GST No :</b>
              </td>
              <td colSpan={2}>{details.gst_no}</td>
              <td colSpan={2}>
                <b>GST No :</b>
              </td>
              <td colSpan={2}>{details.consignee_gst_no}</td>
            </tr>
            {/*<tr> <td colSpan={7}></td></tr>*/}

            <tr className="section_break">
              <td colSpan={7} style={{ backgroundColor: "#f2f2f2" }}></td>
            </tr>

            <tr className="five" style={{ backgroundColor: "#d8d8d8" }}>
              <td>Package</td>
              <td>Method Of Packing</td>
              <td>Description (Said To Contain)</td>
              <td>Weight</td>
              <td>Rate Per MT (Ton)</td>
              <td>Freight To Pay</td>
              <td>To Pay / Remarks</td>
            </tr>

            <tr className="five2">
              <td>1</td>
              <td>{details.packing}</td>
              <td>{details.description}</td>
              <td rowSpan="2">{details.weight}</td>
              <td>{details.rate_per_mt}</td>
              <td>{details.freight_to_pay}</td>
              <td>{details.to_pay_remarks}</td>
            </tr>
            <tr>
              <td rowSpan={6}>
                <b>GP No:</b>
              </td>
              <td rowSpan={6} colSpan={2}>
                {details.gp_no}
              </td>
              <td>Advance</td>
              <td>{details.advance}</td>
            </tr>
            <tr>
              <td rowSpan="4" style={{ textAlign: "center" }}>
                <b>
                  <h3>TBB</h3>
                </b>
              </td>
              <td>SGST</td>
              <td>{details.rate_cgst_sgst}</td>
              <td></td>
            </tr>
            <tr>
              <td>CGST</td>
              <td>{details.rate_cgst_sgst}</td>
              <td></td>
            </tr>
            <tr>
              <td>IGST</td>
              <td>{details.rate_igst}</td>
              <td></td>
            </tr>
            <tr>
              <td>Total</td>
              <td>{details.total}</td>
              <td></td>
            </tr>
            <tr>
              <td>Nt/Weight</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            {/* <div className="five12">
              <h4>GP NO</h4>
              <h4>{details.gp_no}</h4>
            </div> */}

            <tr className="section_break">
              <td colSpan={7} style={{ backgroundColor: "#f2f2f2" }}></td>
            </tr>
            <tr className="sixx">
              <td colSpan={7}>
                <p style={{ textAlign: "right" }}>
                  {" "}
                  For -{" "}
                  <b>
                    {profileDetails?.pro && profileDetails.pro.name
                      ? profileDetails.pro.name
                      : "-----"}
                  </b>
                  <br />
                  <br />
                  Authorised Signature
                </p>
                <p>E-Way Number :{details.eWay_Bill_No}</p>
              </td>
            </tr>
          </table>
        </div>

        <ReactToPrint
          trigger={() => <button>Print this out!</button>}
          content={() => componentRef}
        />

        <button onClick={goBack}>Back</button>
      </div>
    </>
  );
};

export default Printbilty;
